/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Text/Active/Post
 * @desc Active node component for date
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { FilterPostReportText as FilterPostNewIndexText } from 'labstep-web/components/FilterPost/Report/Text';
import { useParamsContext } from 'labstep-web/contexts/params/hook';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import {
  PostFilterComparison,
  PostFilterComparisonHumanReadableShort,
} from 'labstep-web/services/postFilter/constants';
import type React from 'react';
import { getPostFilterText } from '../../Form';
import { COMPARISON_OPTIONS } from '../../Form/fields';

export enum PostFilterComparisonHumanReadable {
  lt = 'Before',
  gt = 'After',
  not_null = 'Has value',
}

export const FilterPostReportTextActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick, index }) => {
  const TEXT_FILTERS = [
    getPostFilterText(
      'name',
      PostFilterComparison.eq,
      'experiment.experimentWorkflow.entityState',
    ),
    getPostFilterText('value', PostFilterComparison.eq),
  ];
  const { addPostFilter } = useParamsContext();
  const filterActive = TEXT_FILTERS.find((filter) =>
    filter.isNodeActive(node),
  );
  if (!filterActive) {
    return null;
  }

  const path = filterActive.getPath() || '';

  const attributes = filterActive.getAttributeValues(node);
  let label = 'name';
  const field = Object.keys(attributes)[0];
  const { comparison } = Object.values(attributes)[0];
  const value =
    comparison === PostFilterComparison.not_null
      ? ''
      : Object.values(attributes)[0].value;

  const defaultValues = {
    comparison: COMPARISON_OPTIONS.find(
      (option) => option.value === comparison,
    ),
    value,
  };

  const postFilterSettings = {
    label,
    path,
    field,
  };

  if (path && path.endsWith('.entityState')) {
    label = 'Experiment Status';
  }
  const comparaisonReadable =
    PostFilterComparisonHumanReadableShort[
      comparison as keyof typeof PostFilterComparisonHumanReadableShort
    ];

  const labelReadable =
    value === ''
      ? 'Name not null'
      : `${label !== 'name' ? label : field} ${comparaisonReadable} ${value}`;

  return (
    <FilterPostNewIndexText
      label={label}
      path={postFilterSettings.path}
      field={postFilterSettings.field}
      addPostFilter={addPostFilter}
      defaultValues={defaultValues}
      viewComponent={({ toggleModal }) => (
        <RemoveLabel
          name={labelReadable}
          onNameClick={toggleModal}
          onRemoveClick={onRemoveClick}
        />
      )}
      replace={index}
    />
  );
};
